import { NewAgreementServiceDetail } from './../models/Entities/AgreementServices/NewAgreementServiceDetail';
import { AgreementServicesDetail } from './../models/Entities/AgreementServices/AgreementServicesDetail';
import { IResult } from '../models/HttpResult';

// Functions
import * as Functions from '../functions/common';

// Error Tracer
import * as Sentry from '@sentry/react';
import authFetch from './httpClient';

const BaseURL =
  process.env.REACT_APP_BILLER_API_GATEWAY + 'agreements/services/';

export const GetServiceDetailsByAgreementId = async (
  agreementId: number
): Promise<AgreementServicesDetail[]> => {

  let RequestURL: string = BaseURL + agreementId + '/details';

  try {
    const Response: AgreementServicesDetail[] = await authFetch(RequestURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        } else {
          return response.json() as Promise<IResult<AgreementServicesDetail[]>>;
        }
      })
      .then((data: IResult<AgreementServicesDetail[]>) => {
        return data.data;
      })
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return Response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const GetAgreementServicesDetailsById = async (
  id: number
): Promise<AgreementServicesDetail> => {

  let RequestURL: string = BaseURL + 'details/' + id;

  try {
  
    const Response: AgreementServicesDetail = await authFetch(RequestURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        } else {
          return response.json() as Promise<IResult<AgreementServicesDetail>>;
        }
      })
      .then((data: IResult<AgreementServicesDetail>) => {
        return data.data;
      })
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return Response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const CreateAgreementServicesDetail = async (
  newAgreementServicesDetail: NewAgreementServiceDetail
): Promise<AgreementServicesDetail> => {

  let RequestURL: string = BaseURL + 'details';

  try {
    
    const Response: AgreementServicesDetail = await authFetch(RequestURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newAgreementServicesDetail)
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        } else {
          return response.json() as Promise<IResult<AgreementServicesDetail>>;
        }
      })
      .then((data: IResult<AgreementServicesDetail>) => {
        return data.data;
      })
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return Response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};

export const UpdateAgreementServicesDetail = async (
  agreementServicesDetail: AgreementServicesDetail
): Promise<AgreementServicesDetail> => {

  let RequestURL: string = BaseURL + 'details/';
  
  try {
    const Response: AgreementServicesDetail = await authFetch(RequestURL, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'PUT',
      body: JSON.stringify(agreementServicesDetail)
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        } else {
          return response.json() as Promise<IResult<AgreementServicesDetail>>;
        }
      })
      .then((data: IResult<AgreementServicesDetail>) => {
        return data.data;
      })
      .catch((error: any) =>
        error.text().then((body: any) => {
          throw Functions.HttpErrorHandler(body, error);
        })
      );

    return Response;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};
